import React, { useState, useEffect } from 'react';
import Header from '../../components/Layout/Header';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import Footer from '../../components/Layout/Footer';
import ScrollToTop from '../../components/Common/ScrollTop';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleServiceFlip from '../../components/Service/SingleServiceFlip';
// import serviceIcon1 from '../../assets/img/industries/1.png'; // Removed static imports for icons
// import serviceIcon2 from '../../assets/img/industries/2.png';
// import serviceIcon3 from '../../assets/img/industries/3.png';
// import serviceIcon4 from '../../assets/img/industries/add.png';
import shapeImg from '../../assets/img/service/s2.png';
import bannerbg from '../../assets/img/breadcrumbs/4.jpg';
import ContactMain from '../industries/ContactMain';
import Brand from '../../components/Common/Brand'
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';


const Blog = () => {
    const [industries, setIndustries] = useState([]);

    useEffect(() => {
        // Fetch industries data from the API
        fetch('https://yautiktechnology.com/api/industries')
            .then((response) => response.json())
            .then((data) => setIndustries(data))
            .catch((error) => console.error('Error fetching industries:', error));
    }, []);

    return (
        <React.Fragment>
            <Header parentMenu='blog' activeMenu='/blog' />
            <div>
                <SiteBreadcrumb
                    pageTitle="OUR INDUSTRIES"
                    titleClass="page-title"
                    pageName="Industries"
                    breadcrumbsImg={bannerbg}
                />
                <div id="rs-service" className="rs-services main-home style2 pt-120 pb-94 md-pt-80 md-pb-60">
                    <div className="container">
                        <SectionTitle
                            sectionClass="sec-title2 text-center mb-46"
                            titleClass="title industries"
                            title="Accelerating innovation and developing competitive edge across industries worldwide. Get the best IT solutions and development capabilities to achieve targeted revenue."
                        />
                        <div className="row">
                            {industries.map((industry) => (
                                <div key={industry.id} className="col-lg-3 col-md-4 mb-26 in">
                                    <SingleServiceFlip
                                        itemClass="flip-box-inner"
                                        serviceImage={industry.icon}
                                        IndTitle={industry.heading}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="shape-animation">
                        <div className="shape-part">
                            <img className="dance" src={shapeImg} alt="images" />
                        </div>
                    </div>
                </div>

                {/* scrolltop-start */}
                <ScrollToTop />
                {/* scrolltop-end */}
            </div>
             {/* Counter Section Start */}
             <CounterStyleThree />
            {/* Counter Section Start */}

            {/* brand-area-start */}
            <Brand />
            {/* brand-area-end */}
            <Footer />
            <SearchModal />

           
        </React.Fragment>
    );
};

export default Blog;
